import React, { useState } from "react";
import BlogCard from "../BlogCard/BlogCard";
import { categories, blogPosts } from "../../blog/data/blogData/BlogData";
import "./../../../../assets/css/general/blog/BlogGrid/BlogGrid.css";

const BlogGrid = () => {
  const [activeCategory, setActiveCategory] = useState("All");

  const filteredPosts =
    activeCategory === "All"
      ? blogPosts
      : blogPosts.filter((post) => post.category === activeCategory);

  return (
    <section className="blog-grid-section">
      <div className="blog-grid-container">
        <div className="blog-grid-header">
          <h2 className="blog-grid-title">
            Latest <span className="blog-grid-prefix">Articles</span>
          </h2>
          <p className="blog-grid-subtitle">
            Explore practical guides, tutorials, and career insights.
          </p>
        </div>

        <div className="blog-filter-tabs">
          {categories.map((category) => (
            <button
              key={category}
              type="button"
              className={`blog-filter-tab ${activeCategory === category ? "active" : ""}`}
              onClick={() => setActiveCategory(category)}
              aria-label={`Filter by ${category}`}
            >
              {category}
            </button>
          ))}
        </div>

        <div className="blog-grid">
          {filteredPosts.map((post) => (
            <BlogCard key={post.id} post={post} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogGrid;
